import axios from "axios";
import { BASE_URL } from "../Global";

export const SendPartnerFormData = async (formData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/partner/partnerform`,
      JSON.stringify(formData),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const SendShopifyFormData = async (formData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/partner/shopifyform`,
      JSON.stringify(formData),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const LoginPartner = async (credentials) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/partner/login`,
      JSON.stringify(credentials),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const SignupPartner = async (userData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/partner/signup`,
      JSON.stringify(userData),
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    // Re-throw the error so it can be properly handled in the calling function
    throw error;
  }
};
